module.exports = __webpack_public_path__ + "img/michelle-pro.4bece69b.jpg";